export const GET_SITES_BY_ACCOUNT = 'GET_SITES_BY_ACCOUNT'
export const GET_PAGINATED_SITES_BY_ACCOUNT = 'GET_PAGINATED_SITES_BY_ACCOUNT'
export const GET_CPANEL_SITES_BY_ACCOUNT = 'GET_CPANEL_SITES_BY_ACCOUNT'
export const GET_MANAGE_SERVICES_BY_ACCOUNT = 'GET_MANAGE_SERVICES_BY_ACCOUNT'
export const POST_MOVE_SERVICE_TO_SITE = 'POST_MOVE_SERVICE_TO_SITE'
export const GET_CONTACTS_BY_SITE = 'GET_CONTACTS_BY_SITE'
export const CLEAR_CACHE_SITE_BY_ID = 'CLEAR_CACHE_SITE_BY_ID'
export const COPY_EXPRESS_SITE_TO_LATEST = 'COPY_EXPRESS_SITE_TO_LATEST'
export const COPY_EXPRESS_SITE = 'COPY_EXPRESS_SITE'

export const POST_EXTERNAL_PLATFORM_EMAIL = 'POST_EXTERNAL_PLATFORM_EMAIL'
export const POST_EXTERNAL_PLATFORM_EMAIL_PENDING = 'POST_EXTERNAL_PLATFORM_EMAIL_PENDING'
export const POST_EXTERNAL_PLATFORM_EMAIL_FULFILLED = 'POST_EXTERNAL_PLATFORM_EMAIL_FULFILLED'
export const POST_EXTERNAL_PLATFORM_EMAIL_ERROR = 'POST_EXTERNAL_PLATFORM_EMAIL_ERROR'

export const DELETE_RESTORE_SITE_BY_ID = 'DELETE_RESTORE_SITE_BY_ID'
export const DELETE_RESTORE_SITE_BY_ID_PENDING = 'DELETE_RESTORE_SITE_BY_ID_PENDING'
export const DELETE_RESTORE_SITE_BY_ID_FULFILLED = 'DELETE_RESTORE_SITE_BY_ID_FULFILLED'
export const DELETE_RESTORE_SITE_BY_ID_ERROR = 'DELETE_RESTORE_SITE_BY_ID_ERROR'
